import Carousel from "react-bootstrap/Carousel";
import { Container, Row, Col } from "react-bootstrap";
import { useState, useMemo } from "react";
import "../vehicleDetail.css";
import MessageIcon from "@mui/icons-material/Message";
import BackArrow from "../../../components/backArrow";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Loader from "../../Loader";
import { getAsset } from "../../../helpers/helper";
import noImagePlaceholder from "../../../assets/images/dummy/no_image_placeholder.png";
import { useGetTransportVehicleByIdQuery } from "../../../features/transport/transportVehicleApiSlice";

const resolveCarouselImages = (images) => {
  const list = Array.isArray(images)
    ? images.flat(Infinity).filter((item) => item && String(item).trim())
    : images && String(images).trim()
      ? [images]
      : [];

  if (!list.length) return [noImagePlaceholder];

  return list.map((item) => {
    const src = getAsset(item);
    if (!src || /\/assets\/?$/.test(src)) return noImagePlaceholder;
    return src;
  });
};

const BuyVehicaldetail = (props) => {
  const { id, shopid } = useParams();
  const [show, setShow] = useState(0);
  const handleShow = () => setShow(1);
  const handleClose = () => setShow(0);
  const navigate = useNavigate();
  const location = useLocation();

  const { data, isLoading, isFetching } = useGetTransportVehicleByIdQuery(id, {
    skip: !id,
  });

  const singleCar = data?.data?.TransportVehicle;
  const isloading = isLoading || isFetching;

  const carouselImages = useMemo(
    () => resolveCarouselImages(singleCar?.images),
    [singleCar?.images],
  );

  return (
    <>
      <Container>
        {isloading ? (
          <Loader heightsetting="screenHeight" />
        ) : (
          <div className={`${props.heightclass} noscroll`}>
            <Row className="screenHeight">
              <Col
                lg="10 mx-auto rounded"
                className="p-4 pt-1"
                style={{ backgroundColor: "#f5f5f5" }}
              >
                <div className="ps-3">
                  <BackArrow />
                </div>
                <Row
                  className="rounded bg-white p-2 mb-2"
                  style={{ boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)" }}
                >
                  <Col
                    sm={12}
                    md={9}
                    lg={12}
                    xl={12}
                    className="pe-0 ps-0 mt-5"
                  >
                    <div className="ps-3 pe-3 pb-2">
                      <Carousel>
                        {carouselImages.map((src, index) => (
                          <Carousel.Item
                            className="img-items text-center"
                            key={index}
                          >
                            <img
                              className="car_img_w"
                              src={src}
                              alt={
                                singleCar?.brandName
                                  ? `${singleCar.brandName} slide ${index + 1}`
                                  : "Vehicle image"
                              }
                              crossOrigin={
                                src === noImagePlaceholder
                                  ? undefined
                                  : "anonymous"
                              }
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = noImagePlaceholder;
                              }}
                            />
                          </Carousel.Item>
                        ))}
                      </Carousel>
                    </div>
                  </Col>
                </Row>
                <Row
                  className="bg-white rounded p-2"
                  style={{ boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)" }}
                >
                  <h3 className="font-bold mt-3">Vehicle Name and Model</h3>
                  <p className="font-grey">
                    {singleCar?.brandName} ({singleCar?.model})
                  </p>
                  <h5>Description</h5>
                  <p className="font-grey">{singleCar?.description}</p>
                  <Row>
                    <Col lg="3">
                      <p className="mb-0">
                        <b>Number Plate</b>
                      </p>
                      <p className="font-grey">{singleCar?.noPlate}</p>
                    </Col>
                    <Col lg="3">
                      <p className="mb-0">
                        <b>Vehicle Colour</b>
                      </p>
                      <p className="font-grey">{singleCar?.color}</p>
                    </Col>
                    <Col lg="6">
                      <h5>Contact us on</h5>
                      {/* <p className="font-grey mb-0">james@gmail.com</p> */}
                      <p className="font-grey">{singleCar?.contact}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" className="text-end">
                      <button className="btn btn-primary">
                        <MessageIcon fontSize="small" /> Messanger
                      </button>
                    </Col>
                  </Row>
                </Row>
              </Col>
            </Row>
          </div>
        )}
      </Container>
    </>
  );
};
export default BuyVehicaldetail;
